import React from "react";

import { Heading, Category } from "../../../components";
import { getPopularTourCategories } from "../../../utils";
import { tours } from "../../../constants";



const TourCategory = () => {

  // Get the Car Categories
  const categories = getPopularTourCategories(tours);

  // Top 5 categories
  const topCategories = categories.slice(0, 5);

  return (

    <section className="categories">

      {/* Section Heading */}
      <Heading title={'Tour Categories'} subTitle={'Adventures by Category'} />

      {/* Category Items */}
      <div className="box-container">

        {/* Map over the categories array to render each category */}
        {topCategories.map(({ index, category, count, image }) => (
          <Category
            key={index}
            index={index}
            category={category}
            count={count}
            image={image}
          />
        ))}

      </div>

    </section>

  );
};

export default TourCategory;